export default __webpack_public_path__ + "static/media/05.1c29cab4.jpg";